import React from "react";
import { Row, Col, Breadcrumb, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SEO from "../../components/SEO";

const Cookiepolicy = () => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate('/');
    };
    return (
        <>
            <SEO
                title="Cookie Policy"
                description="Read Shaadi Material's Cookie Policy and learn how we use cookies, analytics, advertising, and preference settings."
                canonical="https://shaadimaterial.com/cookie-policy"
            />
            <Container className="py-5 policypage">
                <Row className="breadcrumb_part mb-5">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={goBack}>Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Cookie Policy</Breadcrumb.Item>
                        {/* <Breadcrumb.Item active>Thank You Cards</Breadcrumb.Item> */}
                    </Breadcrumb>
                </Row>

                <Row>
                    <Col md={12}>
                        <h2>Cookies Policy</h2>
                        <p><small>Effective Date: August 2026</small></p>

                        <p>Shaadi Material uses cookies and similar technologies to make our website work properly, analyze
                            how it&#39;s used, personalize your experience, and deliver targeted advertising. &quot;Cookies&quot; are small
                            text files that websites can place on your device when you browse a site. They remember
                            information about your visit (such as login status or preferences) and help us learn what interests
                            our users and improve our services. Under privacy laws like the EU&#39;s GDPR and California&#39;s
                            CCPA, we rely on your consent for non-essential cookies. We also align with India&#39;s Digital
                            Personal Data Protection Act, 2023 (DPDPA). Information collected via cookies is governed by our
                            separate Privacy Policy and is not used to identify you personally without consent.</p>
                        <h4 className="mt-4 mb-3">
                            Types of Cookies We Use
                        </h4>
                        <p>Shaadi Material categorizes cookies into four general types:</p>
                        <ul>
                            <li>
                                <b>Strictly Necessary Cookies:</b> These are essential for our site&#39;s basic functions. They enable core
                                features such as user authentication, security, your coin balance and download session, and
                                keeping items in your cart. Without these cookies, some parts of the site would not work properly.
                                We do not require consent for strictly necessary cookies, but you can still disable them in your
                                browser (with possible impact on functionality).
                            </li>
                            <li>
                                <b>Performance/Analytics Cookies:</b> Also known as analytics cookies, these collect data on how visitors
                                use our site. For example, they record pages visited, time spent on pages, and entry/exit points.
                                We use tools like Google Analytics to measure and improve site performance. This helps us
                                understand overall traffic patterns and where the site can be improved, without identifying individual
                                users.
                            </li>
                            <li>
                                <b>Functionality &amp; Personalization Cookies:</b> These cookies remember your searches, browsing
                                activity, and choices — such as the categories you&#39;ve viewed (backdrops, caricatures, decor,
                                elements, flora &amp; fauna), items you&#39;ve saved or downloaded, your preferred file format (PNG or
                                PSD), and display settings — to provide a more personalized experience. Based on this activity, we
                                tailor what you see on the homepage, category pages, and recommendations, so the content
                                shown is more relevant to you as a designer, event planner, or someone sourcing wedding assets.
                                While not strictly required for site operation, these cookies make the browsing experience smoother
                                and more relevant.
                            </li>
                            <li>
                                <b>Advertising/Targeting Cookies:</b> Also called marketing cookies, these track your activity across the
                                Shaadi Material website and other sites to deliver relevant advertisements. They build a profile of
                                your interests to show you ads that match those interests. For example, the Meta (Facebook) Pixel
                                is used to collect data so we can display ads on Meta platforms that are relevant to you. These
                                cookies also help us measure ad effectiveness. We only use such cookies with your consent and
                                allow you to reject them at any time.
                            </li>
                        </ul>
                        <p>
                            Some cookies are set directly by Shaadi Material, while others come from third-party partners we
                            use for analytics, content, or advertising. Third-party cookies are set by domains other than Shaadi
                            Material. For instance, Google and Meta set cookies when you use our site through their services.
                            These third parties may use cookies to track visitor activity across different websites. We do not
                            control these cookies, but their use is subject to those providers&#39; privacy practices.
                        </p>
                        <h4 className="mt-4 mb-3">
                            How Shaadi Material Uses Cookies
                        </h4>
                        <p>Shaadi Material uses cookies in the following ways:</p>

                        <ul>
                            <li><b>Site Functionality:</b> We use strictly necessary cookies to enable core features (e.g. logging in, site
                                navigation, forms, coin balance tracking during checkout). These cookies ensure the site operates
                                smoothly and securely.
                            </li>
                            <li><b>Analytics:</b> We use performance cookies (such as Google Analytics) to analyze traffic and site
                                performance. This data shows us how many people visit Shaadi Material, which pages are most
                                popular, and how visitors navigate the site. We use this information to improve content and site
                                design.
                            </li>
                            <li><b>Personalization:</b> 
                                We use your searches, browsing history, and selections to show you content we
                                think is most relevant — for example, prioritizing floral elements if that&#39;s what you&#39;ve been
                                browsing, or surfacing backdrop designs if you&#39;re planning a wedding on a short timeline. This
                                applies across the homepage, category listings, and search results.
                            </li>
                            <li><b>Advertising:</b> 
                                We use targeting cookies to deliver personalized advertising. For example, we
                                implement the Meta (Facebook) Pixel to track conversions from Facebook ads and to show you
                                ads based on your interests. These cookies allow us to serve ads that are more relevant to you
                                across the web. We only do this after obtaining your consent, and you can opt out at any time.
                            </li>
                        </ul>

                        <h4 className="mt-4 mb-3">
                            What Happens If You Disable Cookies
                        </h4>

                        <p>
                            You can browse and use Shaadi Material with cookies switched off. If you disable non-essential cookies:
                        </p>
                        <p>
                            The site will show generic, non-personalized content — the full range of categories and items will
                            be displayed broadly, rather than tailored to your browsing history, searches, or past selections.
                            Some conveniences may be lost — for example, the site may not remember your favorited items,
                            last-viewed categories, preferred file format, or display settings between visits.
                            Strictly necessary cookies will still operate, since these are required for core functions like login,
                            checkout, and coin balance tracking — the site cannot function securely without them.
                            You may need to re-select preferences or re-enter information each time you visit.
                        </p>

                        <h4 className="mt-4 mb-3">
                           Managing Your Cookie Preferences
                        </h4>
                        <p>
                            Shaadi Material provides tools for you to control your cookie preferences:
                        </p>
                        <ul>
                            <li><b>Cookie Settings Panel:</b>
                                You can manage cookies directly on our site via the Cookie Settings panel
                                or banner. This panel lets you accept or reject cookies by category (strictly necessary, analytics,
                                functionality, advertising). For example, by choosing &quot;Reject All&quot; you can block all non-essential
                                cookies. You can revisit the settings panel anytime (usually found in the footer of the site under
                                &quot;Cookie Settings&quot;) to change your choices.
                            </li>
                            <li><b>Browser Settings:</b>
                                Almost all web browsers allow you to control cookies. You can disable cookies
                                entirely, accept them on a case-by-case basis, or delete cookies that have already been set.
                                Please note that blocking cookies may prevent Shaadi Material from working properly or limit your
                                access to certain features. For instructions, consult your browser&#39;s help menu. (See links in our
                                Privacy Policy, or visit a site like allaboutcookies.org for guidance.)
                            </li>
                            <li><b>Do-Not-Track Signals:</b> Some browsers have &quot;Do Not Track&quot; settings. We currently do not respond
                                to Do-Not-Track signals, but this policy may change if standards are adopted.
                            </li>
                        </ul>
                        <h4 className="mt-4 mb-3">
                            Privacy Policy and Your Rights
                        </h4>
                        <p>
                            Cookies themselves do not typically identify you personally. However, the information collected by
                            cookies is treated as personal data when linked to you. We use this data according to our Privacy
                            Policy, which explains how we collect, use, and protect all personal information. The Privacy Policy
                            also describes your rights under laws like the GDPR, CCPA, and India&#39;s Digital Personal Data
                            Protection Act, 2023 — for example, the right to access, correct, or delete your personal data. If
                            you have questions about your personal data or wish to exercise your rights, please refer to that
                            policy or contact us.
                        </p>
                        <h4 className="mt-4 mb-3">
                            Changes to This Policy
                        </h4>
                        <p>
                           We may update this Cookies Policy from time to time to reflect changes in law or our practices.
                            When we do, we will update the &quot;Effective Date&quot; at the top of the policy. If the changes are
                            significant, we may provide a prominent notice (for example, a banner or email) before the changes
                            take effect. We encourage you to review this policy periodically for the latest information on our use
                            of cookies.
                        </p>
                        <h4 className="mt-4 mb-3">
                            Contact Us
                        </h4>
                        <p>If you have questions about our use of cookies, please contact us at:</p>
                        <p>Shaadi Material Support</p>
                        <p>Email: <span className="text-warning">support@shaadimaterial.com</span></p>
                        <p>
                            <b>Summary:</b> Shaadi Material uses strictly necessary, performance, functionality/personalization, and
                            advertising cookies for site operation, analytics, personalization, and marketing. If you turn cookies
                            off, the site simply shows generic, non-personalized content instead. You can manage your cookie
                            preferences on our website or via your browser settings. For more details on our data practices,
                            please see our Privacy Policy.
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Cookiepolicy;